import { OperationReportForm32Container } from "../../../containers/SupportSystem/OperationReportForm/OperationReportForm32Container"
export function OperationReportForm32Page () {
    return(
        <OperationReportForm32Container/>
    )
}